'use strict';

angular.module('docketbook')
  .controller('companySettingsResourcesController', function (resourceService, xeroService, $q, $scope, Restangular, $state, $window, $stateParams, accessControl, Upload, uuid) {
    mixpanel.track("Opened CompanySettings-Resources Desktop");

    $scope.currentUser = accessControl.currentUser();
    $scope.currentState = $state.current;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.loading = false;
    $scope.allXeroItems = [];
    $scope.filteredXeroItems = [];
    $scope.filteredUoms = [];
    $scope.filteredCategories = [];
    $scope.searchTextXeroItem = "";
    $scope.showDeleted = false;

    $scope.selected = [];
    $scope.selected_deleted = [];

    $scope.deltedQuery = {
      limit: 10,
      page: 1,
      order: 'name'
    };

    $scope.query = {
      limit: 10,
      page: 1,
      order: 'name'
    };

    $scope.listCount = 0;

    $scope.loadDeletedResourceList = function () {
      $scope.selected_deleted = []

      $scope.promise = $q(function (resolve, reject) {
        // setup query params
        var queryParams = {};
        queryParams.limit = $scope.deltedQuery.limit;
        queryParams.offset = $scope.deltedQuery.limit * ($scope.deltedQuery.page - 1);
        queryParams.sort = $scope.deltedQuery.order;
        queryParams.active = 'false';
        resourceService.getResources(queryParams, function (returnData) {
          $scope.allDeletedResources = returnData;
          for (var i = 0; i < $scope.allDeletedResources.length; i++) {
            // check for existing xero item identifier
            if ($scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled && $scope.allDeletedResources[i].externalIdentifiers != null) {
              var existingXeroIdentifier = $scope.allDeletedResources[i].externalIdentifiers.find(function (eid) {
                return eid.type === 'xero';
              });
              if (existingXeroIdentifier) {
                $scope.allDeletedResources[i].xeroID = $scope.allXeroItems.find(function (xeroItem) {
                  return xeroItem.externalId === existingXeroIdentifier.externalId;
                });
              }
            }
            $scope.allDeletedResources[i].editing = false;
          }
          if (queryParams.offset <= 0 && returnData.length < queryParams.limit) {
            $scope.listCount = returnData.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          resolve('Done');
        }, function (error) {
          $scope.allDeletedResources = [];
          reject('Error');
        });
      });
    }

    $scope.loadDeletedResourceList();

    $scope.loadResourceList = function () {
      $scope.selected = []
      $scope.promise = $q(function (resolve, reject) {
        // setup query params
        var queryParams = {};
        queryParams.limit = $scope.query.limit;
        queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
        queryParams.sort = $scope.query.order;
        queryParams.active = 'true';
        resourceService.getResources(queryParams, function (returnData) {
          $scope.allResources = returnData;
          for (var i = 0; i < $scope.allResources.length; i++) {
            // check for existing xero item identifier
            if ($scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled && $scope.allResources[i].externalIdentifiers != null) {
              var existingXeroIdentifier = $scope.allResources[i].externalIdentifiers.find(function (eid) {
                return eid.type === 'xero';
              });
              if (existingXeroIdentifier) {
                $scope.allResources[i].xeroID = $scope.allXeroItems.find(function (xeroItem) {
                  return xeroItem.externalId === existingXeroIdentifier.externalId;
                });
              }
            }
            $scope.allResources[i].editing = false;
          }
          if (queryParams.offset <= 0 && returnData.length < queryParams.limit) {
            $scope.listCount = returnData.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          resolve('Done');
        }, function (error) {
          $scope.allResources = [];
          reject('Error');
        });
      });
    }

    if ($scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled) {
      // Get cached xero items
      xeroService.getXeroItems({ limit: 800 }, function (items) {
        $scope.allXeroItems = items;
        $scope.filteredXeroItems = angular.copy(items);
        $scope.loadResourceList();
      });
    } else {
      $scope.loadResourceList();
    }

    $scope.goTo = function (href) {
      $window.location.href = href;
    }

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };


    /**********************************/
    /***** Secondary Data Models ******/
    /**********************************/

    $scope.allResourceCategories = [];
    $scope.sortedResourceCategories = {};
    $scope.allUoms = [];
    $scope.sortedUoms = {};

    $scope.getResourceCategories = function () {
      resourceService.getResourceCategories(null, function (categories) {
        $scope.allResourceCategories = categories;
        $scope.filteredCategories = categories;
      }, function (err) {
        $scope.allResourceCategories = [];
        $scope.filteredCategories = [];
      });
    }

    $scope.getUoms = function () {
      resourceService.getUoms(null, function (uoms) {
        $scope.allUoms = uoms;
        $scope.filteredUoms = uoms;
      }, function (err) {
        $scope.allUoms = [];
        $scope.filteredUoms = [];
      });
    }

    $scope.getResourceCategories();
    $scope.getUoms();

    /**********************************/
    /***** Resources Functinality *****/
    /**********************************/

    // Create a new resource modal
    $scope.addNewResource = function (cb) {
      var newResource = { name: "", identifier: "", editing: true };
      $scope.allResources.splice(0, 0, newResource);
    }

    // Close new resource modal
    $scope.closeNewResourceModal = function () {
      $("#newResourceModal").fadeOut(100);
      $scope.resourceEdit = {};
    }

    $scope.editResource = function (resource) {
      $scope.resourceEdit = angular.copy(resource);
      $scope.resourceEdit.loading = false;
      //$scope.resourceEdit.category = $scope.resourceEdit.category.id;
      //$scope.resourceEdit.uom = $scope.resourceEdit.uom.id;
      $scope.resourceOriginal = angular.copy(resource);
      $("#newResourceModal").fadeIn(100);
    }

    $scope.refreshResources = function () {
      $scope.loadResourceList();
    }

    // update the uom of the currently edited resource
    $scope.updateResourceUom = function () {
      for (var i = 0; i < $scope.allUoms.length; i++) {
        if ($scope.allUoms[i].id == $scope.resourceEdit.resourceType.uom) {
          $scope.resourceEdit.uom = $scope.allUoms[i];
        }
      }
    }

    // Resource Xero Item Selected
    $scope.resourceXeroItemSelected = function (resource) {
      if (resource.xeroID && !resource.identifier) {
        resource.identifier = resource.xeroID.userCode;
      }
      if (resource.xeroID && !resource.name) {
        resource.name = resource.xeroID.name;
      }
    }

    // Edit resource table row
    $scope.editResourceRow = function (resourceRow) {
      resourceRow.editing = true;
      resourceRow.loading = false;
    }

    $scope.saveResourceRow = function (resourceRow, cb) {
      var resourceSave = angular.copy(resourceRow);
      var valid = true;
      if (resourceRow.name == null || resourceRow.name == "") {
        valid = false;
      }
      if (resourceRow.identifier == null || resourceRow.identifier == "") {
        valid = false;
      }
      if (resourceRow.category == null) {
        valid = false;
      } else {
        resourceSave.category = resourceRow.category.id;
      }
      if (resourceRow.uom == null) {
        valid = false;
      } else {
        resourceSave.uom = resourceRow.uom.id;
      }
      resourceSave.name = resourceRow.name;
      resourceSave.identifier = resourceRow.identifier;

      if (!valid) {
        return false;
      }

      resourceRow.editing = false;
      resourceRow.loading = true;
      if (resourceRow.xeroID && resourceRow.id != null) {
        var existingXeroIdentifier = null;
        if (resourceRow.externalIdentifiers) {
          existingXeroIdentifier = resourceRow.externalIdentifiers.find(function (eid) {
            return eid.type === 'xero';
          });
        }
        if ((!resourceRow.externalIdentifiers) || (existingXeroIdentifier === undefined) || (existingXeroIdentifier === null) || (existingXeroIdentifier.externalId !== resourceRow.xeroID)) {
          resourceSave.externalIdentifiers = {
            add: [{
              type: 'xero',
              externalId: resourceRow.xeroID.externalId
            }]
          };
          if (existingXeroIdentifier !== undefined) {
            resourceSave.externalIdentifiers.delete = [existingXeroIdentifier];
          }
        }
      } else if (resourceRow.xeroID && resourceRow.id == null) {
        resourceSave.externalIdentifiers = [];
        resourceSave.externalIdentifiers.push({
          type: 'xero',
          externalId: resourceRow.xeroID.externalId
        });
      }

      resourceService.saveResource(resourceSave, function (updatedResource) {
        resourceRow.loading = false;
        Object.assign(resourceRow, updatedResource)
        cb && cb()
      }, function (err) {
        resourceRow.loading = false;
        $scope.alertService.presentAutoAlert('saveResource', err);
        cb && cb()
      });
    }

    // Save a new resource for the organisation
    $scope.saveNewResource = function (resource, cb) {
      resource.loading = true;
      resourceService.saveResource(resource, function (updatedResource) {
        resource.loading = false;
        Object.assign(resourceRow, updatedResource)
        if (cb) {
          cb();
        } else {
          $scope.closeNewResourceModal();
          $scope.loadResourceList();
        }
      }, function (err) {
        resource.loading = false;
        $scope.alertService.presentAutoAlert('saveResource', err);
      });
    }

    $scope.saveNewResourceAddAnother = function (resource) {
      $scope.saveNewResource(resource, function () {
        $scope.refreshResources();
        $scope.openNewResourceModal();
      })
    }

    $scope.deleteResource = function (resource) {
      swal({
        title: "Are you sure?",
        text: "You will not be able to recover this resource!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: false,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          resourceService.removeResource(resource.id, function () {
            $scope.refreshResources();
          }, function (err) {
            swal({
              title: "Error!",
              text: "An error occured while deleting the resource.",
              type: "error",
              confirmButtonText: "Ok, got it."
            });
          });
        }
      });
    }

    $scope.deleteSelectedResources = function () {
      var count = $scope.selected.length;
      swal({
        title: "Are you sure?",
        text: count + " resources will be deleted.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          resourceService.deleteBulkResources($scope.selected, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkResources', { status: 202, requestName: 'Delete bulk resources - failures ' + failures.length + ' of ' + $scope.selected.length });
              $scope.loadResourceList();
              $scope.loadDeletedResourceList()
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkResources', { status: 200 });
              $scope.loadResourceList();
              $scope.loadDeletedResourceList()
            }
          });
        }
      });
    }

    const restoreResource = function (resourceList, cb) {
      if (resourceList.length == 0) {
        cb && cb()
        return
      }

      const resource = resourceList.pop()
      const clone = angular.copy(resource)
      clone.active = true
      $scope.saveResourceRow(clone, () => restoreResource(resourceList, cb))
    }

    $scope.restoreSelectedResources = function () {
      restoreResource($scope.selected_deleted, () => {
        $scope.loadDeletedResourceList()
        $scope.loadResourceList()
      })
    }

    $scope.getResTypeFromId = function (id) {
      if (id.id == null) {
        for (var i = 0; i < $scope.allResourceTypes.length; i++) {
          if ($scope.allResourceTypes[i].id == id) {
            return $scope.allResourceTypes[i];
          }
        }
      } else {
        return id;
      }

      return null;
    }

    $scope.searchXeroItemChange = function (resource, searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredXeroItems = angular.copy($scope.allXeroItems);
      } else {
        $scope.filteredXeroItems = [];
        for (var i = 0; i < $scope.allXeroItems.length; i++) {
          if ($scope.allXeroItems[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1 ||
            $scope.allXeroItems[i].userCode.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredXeroItems.push($scope.allXeroItems[i]);
          }
        }
      }
    }

    $scope.searchUomChange = function (resource, searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredUoms = angular.copy($scope.allUoms);
      } else {
        $scope.filteredUoms = [];
        for (var i = 0; i < $scope.allUoms.length; i++) {
          if ($scope.allUoms[i].abbreviation.toLowerCase().indexOf(searchText.toLowerCase()) != -1 ||
            $scope.allUoms[i].description.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredUoms.push($scope.allUoms[i]);
          }
        }
      }
    }

    $scope.searchCategoryChange = function (resource, searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredCategories = angular.copy($scope.allResourceCategories);
      } else {
        $scope.filteredCategories = [];
        for (var i = 0; i < $scope.allResourceCategories.length; i++) {
          if ($scope.allResourceCategories[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredCategories.push($scope.allResourceCategories[i]);
          }
        }
      }
    }



    /***********************/
    /* RESOURCE CATEGORIES */
    /***********************/

    $scope.resourceCategoriesSelected = [];
    $scope.resourceCategoriesQuery = {
      limit: 100,
      page: 1,
      order: 'name'
    };
    $scope.resourceCategoriesListCount = 0;


    $scope.loadCategoriesList = function () {
      $scope.promise = $q(function (resolve, reject) {
        var queryParams = {};
        queryParams.limit = $scope.resourceCategoriesQuery.limit;
        queryParams.offset = $scope.resourceCategoriesQuery.limit * ($scope.resourceCategoriesQuery.page - 1);
        queryParams.sort = $scope.resourceCategoriesQuery.order;
        resourceService.getResourceCategories(queryParams, function (categories) {
          $scope.allResourceCategories = categories;
          if (queryParams.offset <= 0 && categories.length < queryParams.limit) {
            $scope.resourceCategoriesListCount = categories.length;
          } else {
            $scope.resourceCategoriesListCount = queryParams.offset + (queryParams.limit + 1);
          }
          resolve('Done');
        }, function (err) {
          $scope.allResourceCategories = [];
          reject('Error');
        });
      });
    }

    $scope.loadCategoriesList();

    // Create a new resource type modal
    $scope.openNewResourceCategoryModal = function () {
      $scope.itemEdit = {};
      $("#newResourceCategoryModal").fadeIn(100);
    }

    // Close new resource modal
    $scope.closeNewResourceCategoryModal = function () {
      $("#newResourceCategoryModal").fadeOut(100, function () {
        $scope.itemEdit = {};
      });
    }

    $scope.editResourceCategory = function (item) {
      $scope.itemEdit = item;
      item.loading = false;
      $("#newResourceCategoryModal").fadeIn(100);
    }

    var refreshResourceCategories = function () {
      $scope.loadCategoriesList();
    }

    // Save a new resource cat for the organisation
    $scope.saveNewResourceCategory = function (category) {
      category.loading = true;
      resourceService.saveResourceCategory(category, function (updatedCategory) {
        $("#newResourceCategoryModal").fadeOut(100);
        $scope.loadCategoriesList();
      }, function (err) {
        category.loading = false;
        $scope.alertService.presentAutoAlert('saveResourceCategory', err);
      });
    }

    $scope.deleteSelectedCategories = function () {
      var count = $scope.resourceCategoriesSelected.length;
      swal({
        title: "Are you sure?",
        text: count + " categories will be deleted.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          resourceService.deleteBulkResourceCategories($scope.resourceCategoriesSelected, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', { status: 202, requestName: 'Delete bulk resource categories - failures ' + failures.length + ' of ' + $scope.resourceCategoriesSelected.length });
              $scope.loadCategoriesList();
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', { status: 200 });
              $scope.loadCategoriesList();
            }
          });
        }
      });
    }


    /*****************/
    /* UOMS Settings */
    /*****************/

    $scope.uomsQuery = {
      limit: 100,
      page: 1,
      order: 'abbreviation'
    };
    $scope.uomsSelected = [];
    $scope.uomsListCount = 0;

    $scope.timeTypes = ['hours', 'hoursminutes', 'minutes'];

    $scope.loadUomsList = function () {
      $scope.promise = $q(function (resolve, reject) {
        var queryParams = {};
        queryParams.limit = $scope.uomsQuery.limit;
        queryParams.offset = $scope.uomsQuery.limit * ($scope.uomsQuery.page - 1);
        resourceService.getUoms(queryParams, function (uoms) {
          $scope.allUoms = uoms;
          if (queryParams.offset <= 0 && uoms.length < queryParams.limit) {
            $scope.uomsListCount = uoms.length;
          } else {
            $scope.uomsListCount = queryParams.offset + (queryParams.limit + 1);
          }
          resolve('Done');
        }, function (err) {
          $scope.allUoms = [];
          reject('Error');
        });
      });
    }

    $scope.loadUomsList();

    // Create a new uom modal
    $scope.openNewUomModal = function () {
      $scope.uomEdit = {};
      $scope.uomEdit.isTime = false;
      $("#newUomModal").fadeIn(100);
    }

    $scope.editUom = function (uom) {
      $scope.uomEdit = uom;
      $("#newUomModal").fadeIn(100);
    }

    // Close new uom modal
    $scope.closeNewUomModal = function () {
      $("#newUomModal").fadeOut(100);
      $scope.uomEdit = {};
    }

    // Save a new uom for the organisation
    $scope.saveNewUom = function (uom) {
      uom.loading = true;
      if (uom.isTime == null) {
        uom.isTime = false;
      }
      resourceService.saveUom(uom, function (updatedUom) {
        $scope.closeNewUomModal();
        $scope.loadUomsList();
      }, function (err) {
        uom.loading = false;
        $scope.alertService.presentAutoAlert('saveUom', err);
      });
    }

    $scope.deleteUom = function (uom) {
      swal({
        title: "Are you sure?",
        text: "You will not be able to recover this unit of measure!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: false,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          resourceService.removeUom(uom.id, function (success) {
            swal("Deleted!", "The unit of measure has been deleted.", "success");
            $scope.loadUomsList();
          }, function (err) {
            swal({
              title: "Error!",
              text: "An error occured while deleting the unit of measure.",
              type: "error",
              confirmButtonText: "Ok, got it."
            });
          });
        }
      });
    }

    $scope.deleteSelectedUoms = function () {
      var count = $scope.uomsSelected.length;
      swal({
        title: "Are you sure?",
        text: count + " uom's will be deleted.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          resourceService.deleteBulkUoms($scope.uomsSelected, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkUoms', { status: 202, requestName: 'Delete bulk uoms - failures ' + failures.length + ' of ' + $scope.uomsSelected.length });
              $scope.loadUomsList();
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkUoms', { status: 200 });
              $scope.loadUomsList();
            }
          });
        }
      });
    }

    $scope.userIsXeroAuthenticated = function () {
      if (!$scope.currentUser.xeroAuthentication) {
        return false;
      }
      if (!$scope.currentUser.xeroAuthentication.authenticatedUntil) {
        return false;
      }
      if (moment($scope.currentUser.xeroAuthentication.authenticatedUntil).isBefore(moment())) {
        return false;
      }
      return true;
    }


  });



// WEBPACK FOOTER //
// ./src/controllers/companySettings/resources.js